import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'

import AuthReducer, { NAME as AuthReducerName } from './auth/reducer'
import UserReducer, { NAME as UserReducerName } from './user/reducer'
import IncidentsReducer, {
  NAME as IncidentsReducerName,
} from './incidents/reducer'
import BuffersReducer, { NAME as BufferReducerName } from './buffers/reducer'
import AIReducer, { NAME as AIReducerName } from './ai/reducer'
import AILayerReducer, { NAME as AILayerReducerName } from './aiLayers/reducer'
import OverlayReducer, { NAME as OverlayReducerName } from './overlays/reducer'
import CrimeCategoryReducer, {
  NAME as CrimeCategoryReducerName,
} from './crimeCategories/reducer'
import PalmettoReducer, {
  NAME as PalmettoReducerName,
} from './palmetto/reducer'
import SigEventsReducer, {
  NAME as SigEventsReducerName,
} from './sigevents/reducer'
import RoadClosuresReducer, {
  NAME as RoadClosuresReducerName,
} from './roadClosures/reducer'
import AddressSearchReducer, {
  NAME as AddressSearchReducerName,
} from './search/reducer'
import MapReducer, { NAME as MapReducerName } from './map/reducer'

export default function configureStore(initialState) {
  const reducers = {
    [AuthReducerName]: AuthReducer,
    [UserReducerName]: UserReducer,
    [IncidentsReducerName]: IncidentsReducer,
    [BufferReducerName]: BuffersReducer,
    [AIReducerName]: AIReducer,
    [AILayerReducerName]: AILayerReducer,
    [CrimeCategoryReducerName]: CrimeCategoryReducer,
    [OverlayReducerName]: OverlayReducer,
    [PalmettoReducerName]: PalmettoReducer,
    [SigEventsReducerName]: SigEventsReducer,
    [RoadClosuresReducerName]: RoadClosuresReducer,
    [AddressSearchReducerName]: AddressSearchReducer,
    [MapReducerName]: MapReducer,
  }

  const middleware = [thunk]

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = []
  const isDevelopment = process.env.NODE_ENV === 'development'
  if (
    isDevelopment &&
    typeof window !== 'undefined' &&
    window.devToolsExtension
  ) {
    enhancers.push(window.devToolsExtension())
  }

  const rootReducer = combineReducers({
    ...reducers,
  })

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  )
}
